import { put, call, all } from 'redux-saga/effects';
import { apiPortfolioWalletsGet } from '../api/portfolio';
import {
  PORTFOLIO_WALLETS_GET,
  WALLETS_TRANSACTIONS_GET,
  WALLETS_WITH_TRANSACTIONS_GET,
  WALLETS_TRANSACTIONS_POST,
} from '../actions/types';
import { createQadraSaga } from './shared';
import { apiTransactionsGet, apiTransactionsPost } from '../api/wallet';
import { actionModalOpen } from '../actions';
import { accountGet } from './account';
import { investmentObjectiveGet } from './investmentObjectives';

export function* walletsGet({ payload: { portfolioId } }) {
  const { wallets } = yield call(apiPortfolioWalletsGet, portfolioId);
  yield put({
    type: PORTFOLIO_WALLETS_GET._SUCCESS,
    payload: { portfolioId, wallets },
  });
}

const watchWalletsGet = createQadraSaga(walletsGet, {
  action: PORTFOLIO_WALLETS_GET._REQUEST,
});

function* walletTransactionsGet({ payload: { accountId, walletId } }) {
  const { walletTransactions } = yield call(apiTransactionsGet, walletId);
  yield put({
    type: WALLETS_TRANSACTIONS_GET._SUCCESS,
    payload: { accountId, walletId, transactions: walletTransactions },
  });
}

const watchWalletTransactionsGet = createQadraSaga(walletTransactionsGet, {
  action: WALLETS_TRANSACTIONS_GET._REQUEST,
});

export function* walletWithTransactionsGet({ payload: { portfolioId } }) {
  const { wallets } = yield call(apiPortfolioWalletsGet, portfolioId);

  const calls = wallets.map((w) => call(apiTransactionsGet, w.id));
  const transactionsArr = yield all(calls);

  const walletsWithTransactions = wallets.map((w, i) => ({
    ...w,
    transactions: transactionsArr[i].walletTransactions,
  }));

  yield put({
    type: WALLETS_WITH_TRANSACTIONS_GET._SUCCESS,
    payload: { portfolioId, wallets: walletsWithTransactions },
  });
}

const watchWalletsWithTransactionsGet = createQadraSaga(walletWithTransactionsGet, {
  action: WALLETS_WITH_TRANSACTIONS_GET._REQUEST,
});

function* walletTransactionsPost({
  payload: {
    accountId,
    walletId,
    investmentObjectiveId,
    amount,
    portfolioId,
    type,
    pin,
    popupOnConfirm,
  },
}) {
  yield call(apiTransactionsPost, walletId, { amount, portfolioId, type, pin });
  yield all([
    call(walletWithTransactionsGet, { payload: { accountId } }),
    investmentObjectiveId && call(investmentObjectiveGet, { payload: { investmentObjectiveId } }),
    call(accountGet, { payload: { accountId } }),
  ]);
  if (popupOnConfirm) yield put(actionModalOpen(popupOnConfirm));
}

const watchWalletTransactionPost = createQadraSaga(walletTransactionsPost, {
  action: WALLETS_TRANSACTIONS_POST._REQUEST,
});

export default [
  watchWalletsGet,
  watchWalletTransactionsGet,
  watchWalletsWithTransactionsGet,
  watchWalletTransactionPost,
];
